import { Text } from "@simplybusiness/mobius";

type BindRestrictionProps = {
  offlinePurchaseOnlyRfq: boolean | undefined;
  showBindRestrictions: boolean | undefined;
};

export const BindRestriction = ({
  offlinePurchaseOnlyRfq,
  showBindRestrictions,
}: BindRestrictionProps) => {
  if (!offlinePurchaseOnlyRfq) return null;

  return (
    <>
      {showBindRestrictions ? (
        <Text className="mobius-quote-card__bind-disable">
          Purchase by phone
        </Text>
      ) : (
        <Text className="mobius-quote-card__bind-able">Purchase online</Text>
      )}
    </>
  );
};
